import { render, staticRenderFns } from "./side-navigation.vue?vue&type=template&id=062c2342&scoped=true&"
import script from "./side-navigation.vue?vue&type=script&lang=js&"
export * from "./side-navigation.vue?vue&type=script&lang=js&"
import style0 from "./side-navigation.vue?vue&type=style&index=0&id=062c2342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c2342",
  null
  
)

export default component.exports